var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntermediate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39.923,
    height: 42.829,
    viewBox: "0 0 39.923 42.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_18949",
    x: 3.667,
    y: 10.438,
    width: 32.391,
    height: 32.391,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_18950",
    x: 6.5,
    y: 13.388,
    width: 26.827,
    height: 26.827,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_18951",
    x: 3.816,
    y: 0,
    width: 24.491,
    height: 26.648,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_18952",
    x: 9.009,
    y: 0,
    width: 26.901,
    height: 27.629,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7153",
    "data-name": "Group 7153",
    transform: "translate(-104.295 -185.362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7151",
    "data-name": "Group 7151",
    transform: "translate(104.295 186.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Polygon_70",
    "data-name": "Polygon 70",
    transform: "translate(0 0)",
    fill: "#f8a642"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 27.05220794677734 33.64999771118164 L 12.87061882019043 33.64999771118164 C 11.4445686340332 33.64999771118164 10.11647891998291 32.88237762451172 9.404618263244629 31.64670753479004 L 2.304348707199097 19.32170677185059 C 1.594838619232178 18.090087890625 1.594838619232178 16.55989646911621 2.304348707199097 15.32827663421631 L 9.404628753662109 3.003286838531494 C 10.11647891998291 1.767606973648071 11.4445686340332 0.9999969601631165 12.87061882019043 0.9999969601631165 L 27.05220794677734 0.9999969601631165 C 28.47825813293457 0.9999969601631165 29.80634880065918 1.767606973648071 30.51819801330566 3.003286838531494 L 37.61846923828125 15.32828712463379 C 38.32799911499023 16.55990600585938 38.32799911499023 18.090087890625 37.61846923828125 19.32170677185059 L 30.51819801330566 31.64670753479004 C 29.80634880065918 32.88238525390625 28.47825813293457 33.64999771118164 27.05220794677734 33.64999771118164 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12.87061882019043 1.999996185302734 C 11.80107879638672 1.999996185302734 10.80500793457031 2.575706481933594 10.2711181640625 3.502466201782227 L 3.170848846435547 15.82745742797852 C 2.638710021972656 16.75116729736328 2.638710021972656 17.89881706237793 3.170848846435547 18.8225269317627 L 10.2711181640625 31.14752769470215 C 10.80500793457031 32.07428741455078 11.80107879638672 32.64999771118164 12.87061882019043 32.64999771118164 L 27.05220794677734 32.64999771118164 C 28.12173843383789 32.64999771118164 29.1178092956543 32.07428741455078 29.65169906616211 31.14752769470215 L 36.75196838378906 18.8225269317627 C 37.28410720825195 17.89881706237793 37.28410720825195 16.75116729736328 36.75196838378906 15.82745742797852 L 29.65169906616211 3.502466201782227 C 29.1178092956543 2.575706481933594 28.12173843383789 1.999996185302734 27.05220794677734 1.999996185302734 L 12.87061882019043 1.999996185302734 M 12.87061882019043 -3.814697265625e-06 L 27.05220794677734 -3.814697265625e-06 C 28.84022903442383 -3.814697265625e-06 30.49215888977051 0.9547882080078125 31.38469886779785 2.504108428955078 L 38.48497009277344 14.82909774780273 C 39.37496948242188 16.3740177154541 39.37496948242188 18.27597618103027 38.48497009277344 19.82088661193848 L 31.38469886779785 32.1458854675293 C 30.49215888977051 33.69520568847656 28.84022903442383 34.64999771118164 27.05220794677734 34.64999771118164 L 12.87061882019043 34.64999771118164 C 11.08259773254395 34.64999771118164 9.430658340454102 33.69520568847656 8.538118362426758 32.1458854675293 L 1.437847137451172 19.82088661193848 C 0.5478401184082031 18.27596664428711 0.5478401184082031 16.3740177154541 1.437847137451172 14.82909774780273 L 8.538118362426758 2.504108428955078 C 9.430667877197266 0.9547882080078125 11.08259773254395 -3.814697265625e-06 12.87061882019043 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#ffe87a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7154",
    "data-name": "Group 7154",
    transform: "translate(116.962 191.362)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -12.67, -6)",
    filter: "url(#Path_18949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18949-2",
    "data-name": "Path 18949",
    d: "M27.6,56.435a.8.8,0,0,1,.162.929l-.207.416A1.8,1.8,0,0,0,27.6,59.47a1.754,1.754,0,0,0,1.423.888l.459.027a.778.778,0,0,1,.714.606l.106.453a1.77,1.77,0,0,0,1.112,1.264,1.74,1.74,0,0,0,1.654-.245l.369-.278a.778.778,0,0,1,.932,0l.369.278a1.741,1.741,0,0,0,1.654.245,1.771,1.771,0,0,0,1.112-1.264l.106-.453a.778.778,0,0,1,.714-.606l.459-.027a1.754,1.754,0,0,0,1.423-.888,1.8,1.8,0,0,0,.049-1.691l-.207-.416a.8.8,0,0,1,.162-.928l.335-.32a1.792,1.792,0,0,0-.511-2.932L39.616,53a.8.8,0,0,1-.466-.817l.053-.462a1.788,1.788,0,0,0-.617-1.572,1.742,1.742,0,0,0-1.638-.342l-.441.134a.771.771,0,0,1-.876-.322l-.253-.389a1.75,1.75,0,0,0-2.943,0l-.253.389a.781.781,0,0,1-.876.322l-.441-.134a1.744,1.744,0,0,0-1.638.342,1.788,1.788,0,0,0-.617,1.572l.053.462A.8.8,0,0,1,28.2,53l-.423.184a1.792,1.792,0,0,0-.511,2.932Zm6.308-6.052a5.406,5.406,0,1,1-5.344,5.406,5.406,5.406,0,0,1,5.344-5.406Z",
    transform: "translate(-14.05 -31.99)",
    fill: "#ffe87a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -12.67, -6)",
    filter: "url(#Path_18950)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18950-2",
    "data-name": "Path 18950",
    d: "M40.243,66.8a4.413,4.413,0,1,0-4.362-4.413A4.413,4.413,0,0,0,40.243,66.8Z",
    transform: "translate(-20.38 -38.58)",
    fill: "#fac404"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -12.67, -6)",
    filter: "url(#Path_18951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18951-2",
    "data-name": "Path 18951",
    d: "M33.684,10.1,30.968,5H27.193l4.6,8.648Z",
    transform: "translate(-14.38 1)",
    fill: "#ff2300"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -12.67, -6)",
    filter: "url(#Path_18952)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18952-2",
    "data-name": "Path 18952",
    d: "M47.775,14.629,52.9,5H49.126L44,14.629Z",
    transform: "translate(-25.99 1)",
    fill: "#ff2300"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntermediate);
export default __webpack_public_path__ + "static/media/intermediate.774e23a9d8818aafee0d2ed4530737b6.svg";
export { ForwardRef as ReactComponent };